import { fixColorMap } from '@/config/constants';
import { reverseCoords } from '@/utils/coords';
import L from 'leaflet';

export function createCellCircle(position, divide = 1000) {
  const radius = position.accuracy / divide ?? 1;
  const latlng = reverseCoords(position.location);
  return L.circle(latlng, {
    radius,
    color: fixColorMap.cell,
    weight: 1,
    opacity: 0.2,
    fillColor: fixColorMap.cell,
    fillOpacity: 0.07,
    pane: 'cellfixes',
  });
}

export function createWifiCircle(position, divide = 1000) {
  const radius = position.accuracy / divide ?? 1;
  const latlng = reverseCoords(position.location);
  return L.circle(latlng, {
    radius,
    color: fixColorMap.wifi,
    weight: 1,
    opacity: 0.3,
    fillColor: fixColorMap.wifi,
    fillOpacity: 0.15,
    pane: 'wififixes',
  });
}
